module.exports = __webpack_public_path__ + "static/lineart-texture-dark-a57623740f6124a11046353192fe48c0.svg";